import { Grid, List, ListItem, Radio, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { EstateType } from 'queries';

type Props = {
  estateType: EstateType;
  selected: boolean;
  setSelected: (isSelected: boolean) => void;
};

const useStyles = makeStyles(() => ({
  estateTypeRow: {
    paddingTop: '15px',
    paddingBottom: '15px',
  },
  estateTypeIcon: {
    textAlign: 'center',
    height: '130px',
    paddingBottom: '15px',
  },
  estateTypeLabel: {
    textAlign: 'center',
    fontSize: '14px',
  },
  estateDescriptionContainer: {
    padding: '5px',
    margin: '7px',
  },
  estateDescription: {
    fontSize: '14px',
  },
  estateTypeRadio: {
    color: 'black',
  },
  labelContainer: {
    minHeight: '90px',
  },
  list: {
    listStyleType: 'disc',
  },
  listItem: {
    display: 'list-item',
    padding: '0',
    marginLeft: '30px',
  },
}));

type EstateTypeDetail = {
  [key in EstateType]: {
    img: string;
    label: string;
  };
};

const estateTypeDetail: EstateTypeDetail = {
  [EstateType.Truadmin]: {
    img: '/truadmin.svg',
    label: 'Post-Death Administration',
  },
  [EstateType.Truplanning]: {
    img: '/truplanning.svg',
    label: 'Planning + Funding',
  },
  [EstateType.Truproxy]: {
    img: '/truproxy.svg',
    label: 'POA + Guardianship',
  },
  [EstateType.Trustadmin]: {
    img: '/trustadmin.svg',
    label: 'Trust Management',
  },
};

export default function EstateTypeSelectBox({ estateType, selected, setSelected }: Props) {
  const classes = useStyles();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const estateTypeRadioOnChange = (e: any) => {
    const isSelected = e.target.checked;
    setSelected(isSelected);
  };

  return (
    <Grid key={estateType} className={classes.estateTypeRow} item xs={3} sm={3}>
      <Grid className={classes.estateTypeIcon} item xs={12} sm={12}>
        <img src={estateTypeDetail[estateType].img} alt={estateTypeDetail[estateType].label} />
      </Grid>
      <Grid container justifyContent="center" className={classes.labelContainer}>
        <Grid className={classes.estateTypeLabel} item xs={10} sm={10}>
          <b>{estateTypeDetail[estateType].label}</b>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12}>
        <Radio
          color="primary"
          className={classes.estateTypeRadio}
          checked={selected}
          onChange={estateTypeRadioOnChange}
        />
      </Grid>
      <Grid className={classes.estateDescriptionContainer} item xs={12} sm={12}>
        {estateType === EstateType.Truadmin && (
          <Typography className={classes.estateDescription}>
            <strong>Popular Tasks Include: </strong>
            <List className={classes.list}>
              <ListItem className={classes.listItem}>Probate Docs</ListItem>
              <ListItem className={classes.listItem}>Asset & Liability Searches</ListItem>
              <ListItem className={classes.listItem}>Obtain DOD Values</ListItem>
              <ListItem className={classes.listItem}>Close Out/Transfer Accounts</ListItem>
            </List>
          </Typography>
        )}
        {estateType === EstateType.Truplanning && (
          <Typography className={classes.estateDescription}>
            <strong>Popular Tasks Include: </strong>
            <List className={classes.list}>
              <ListItem className={classes.listItem}>Estate Planning Docs</ListItem>
              <ListItem className={classes.listItem}>Generate Deeds to Trust</ListItem>
              <ListItem className={classes.listItem}>
                Institution Specific Trust Funding Forms
              </ListItem>
            </List>
          </Typography>
        )}
        {estateType === EstateType.Truproxy && (
          <Typography className={classes.estateDescription}>
            <strong>Popular Tasks Include: </strong>
            <List className={classes.list}>
              <ListItem className={classes.listItem}>Asset and Liability Searches</ListItem>
              <ListItem className={classes.listItem}>Customizable Workflows</ListItem>
              <ListItem className={classes.listItem}>Account Management</ListItem>
            </List>
          </Typography>
        )}
        {estateType === EstateType.Trustadmin && (
          <Typography className={classes.estateDescription}>
            <strong>Popular Tasks Include: </strong>
            <List className={classes.list}>
              <ListItem className={classes.listItem}>Trustee Appointments/Succession</ListItem>
              <ListItem className={classes.listItem}>Crummey Notices</ListItem>
              <ListItem className={classes.listItem}>Post Death Trust Administration</ListItem>
            </List>
          </Typography>
        )}
      </Grid>
    </Grid>
  );
}
